import { FormattedMessage, injectIntl, intlShape } from 'react-intl'
import { Link } from 'react-router-dom'
import ImmutablePropTypes from 'react-immutable-proptypes'
import IsRole from '../containers/IsRole'
import React from 'react'
import Select from '../../../ui/Select'
import styles from './css/Navigation.scss'
import { SessionAwareComponent } from '../../../lib/api/components/SessionAwareComponent'
import Menu from 'react-burger-menu/lib/menus/slide'

/* eslint-disable */

@injectIntl
export default class Navigation extends SessionAwareComponent {
    constructor (props) {
        super(props)
        this.state = {
            menuOpen: false
        }
    }

    static propTypes = {
        intl: intlShape.isRequired,
        languages: ImmutablePropTypes.list.isRequired,
        session: ImmutablePropTypes.map.isRequired,
    }


    handleRegionSelect = (e) => {
        e.preventDefault();
        document.location.href =
            (document.location.origin || '')
            + '/' + (document.location.path || '')
            + '?lang=' + (e.target.value || 'de');
    }

    handleStateChange (state) {
        this.setState({menuOpen: state.isOpen})
    }

    closeMenu () {
        this.setState({menuOpen: false})
    }

    _getBackendUrl() {
        const { session } = this.props;
        const user = session.get('user');

        if (user) {
            const features = user.get('features');
            if (features && features.get('nextGenAdmin')) {
                return '/admin';
            }
        }

        return '/classic/#/admin';
    }

    render() {
        return (
            <div>
                <div className={styles.menuContainer}>
                    <div className={styles.container}>
                        {this.renderItems()}
                    </div>
                </div>

                <div className={styles.bmMenuContainer}>
                    <Menu
                        left
                        isOpen={ this.state.menuOpen }
                        onStateChange={ (state) => this.handleStateChange(state) }
                        burgerButtonClassName={styles.bmBurgerButton}
                        burgerBarClassName={styles.bmBurgerBars}
                        crossButtonClassName={styles.bmCrossButton}
                        crossClassName={styles.bmCross}
                        menuClassName={styles.bmMenu}
                        morphShapeClassName={styles.bmMorphShape}
                        itemClassName={styles.bmItem}
                        itemListClassName={styles.bmItemList}
                        overlayClassName={styles.bmOverlay}
                    >
                        {this.renderItems()}
                    </Menu>
                </div>
            </div>
        );
    }

    renderItems() {
        const { session, languages } = this.props;
        const { formatMessage } = this.props.intl;

        return (
            <div className={styles.listContainer}>
                <IsRole role='guest'>
                    <ul className={styles.list}>
                        <li>
                            <Link to='/orders/tracking' onClick={() => this.closeMenu()}>
                                <FormattedMessage id='navigation.link.tracking' />
                            </Link>
                        </li>
                        <li>
                            <Link to='/auth/login' onClick={() => this.closeMenu()}>
                                <FormattedMessage id='navigation.link.login' />
                            </Link>
                        </li>
                        <li>
                            <Link to='/auth/register' onClick={() => this.closeMenu()}>
                                <FormattedMessage id='navigation.link.register' />
                            </Link>
                        </li>
                    </ul>
                </IsRole>

                <IsRole role={['user', 'admin']}>
                    <ul className={styles.list}>
                        <IsRole role={['admin']}>
                            <li>
                                <a href={this._getBackendUrl()}>
                                    <FormattedMessage id='navigation.link.backend' />
                                </a>
                            </li>
                        </IsRole>
                        <li>
                            <Link to='/' onClick={() => this.closeMenu()}>
                                <FormattedMessage id='navigation.link.new_order' />
                            </Link>
                        </li>
                        <li>
                            {/* TODO: The url is fixed, is this ok? */}
                            <Link to='/orders/tracking' onClick={() => this.closeMenu()}>
                                <FormattedMessage id='navigation.link.tracking' />
                            </Link>
                        </li>
                        <li>
                            <Link to='/profile' onClick={() => this.closeMenu()}>
                                <FormattedMessage id='navigation.link.account' />
                            </Link>
                            <ul className={styles.dropdown}>
                                <li>
                                    <Link to='/addressbook' onClick={() => this.closeMenu()}>
                                        <FormattedMessage id='navigation.link.addressbook' />
                                    </Link>
                                </li>
                                <li>
                                    <Link to='/addressbook/manage' onClick={() => this.closeMenu()}>
                                        <FormattedMessage id='navigation.link.addressbook_manage' />
                                    </Link>
                                </li>
                                <li>
                                    <Link to='/orders' onClick={() => this.closeMenu()}>
                                        <FormattedMessage id='navigation.link.orders' />
                                    </Link>
                                </li>
                                <li>
                                    <Link to='/settings' onClick={() => this.closeMenu()}>
                                        <FormattedMessage id='navigation.link.settings' />
                                    </Link>
                                </li>
                                <li>
                                    <Link to='/select' onClick={() => this.closeMenu()}>
                                        <FormattedMessage id='navigation.link.select_tenant' />
                                    </Link>
                                </li>
                                <li>
                                    <Link to='/certificate' onClick={() => this.closeMenu()}>
                                        <FormattedMessage id='navigation.link.certificate' />
                                    </Link>
                                </li>
                                <li>
                                    <Link to='/auth/logout' onClick={() => this.closeMenu()}>
                                        <FormattedMessage id='navigation.link.logout' />
                                    </Link>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </IsRole>

                {/* If needed, this could be extracted into its own component easily */}
                <Select
                    value={session.get('locale') || ''}
                    onChange={this.handleRegionSelect}
                    className={styles.select}
                    small
                >
                    {languages.map(lang => (
                        <option value={lang} key={lang}>
                            {formatMessage({id: `frontend.language_switcher.select.option.${lang}`})}
                        </option>
                    )).toArray()}
                </Select>
            </div>
        );
    }
}
